"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.checkoutErrorSelector = exports.checkoutCouponSelector = exports.checkoutShippingSelector = exports.checkoutProductSelector = exports.checkoutOrderSelector = exports.checkoutDataSelector = exports.checkoutContextSelector = void 0;

var _reselect = require("reselect");

var checkoutSelector = function checkoutSelector(state) {
  return state.checkout;
};

var checkoutContextSelector = (0, _reselect.createSelector)(checkoutSelector, function (checkout) {
  return checkout.context;
});
exports.checkoutContextSelector = checkoutContextSelector;
var checkoutDataSelector = (0, _reselect.createSelector)(checkoutSelector, function (checkout) {
  return checkout.data;
});
exports.checkoutDataSelector = checkoutDataSelector;
var checkoutOrderSelector = (0, _reselect.createSelector)(checkoutSelector, function (checkout) {
  return checkout.data.order;
});
exports.checkoutOrderSelector = checkoutOrderSelector;
var checkoutProductSelector = (0, _reselect.createSelector)(checkoutSelector, function (checkout) {
  return checkout.data.product;
});
exports.checkoutProductSelector = checkoutProductSelector;
var checkoutShippingSelector = (0, _reselect.createSelector)(checkoutSelector, function (checkout) {
  return checkout.data.shipping;
});
exports.checkoutShippingSelector = checkoutShippingSelector;
var checkoutCouponSelector = (0, _reselect.createSelector)(checkoutSelector, function (checkout) {
  return checkout.data.coupon;
});
exports.checkoutCouponSelector = checkoutCouponSelector;
var checkoutErrorSelector = (0, _reselect.createSelector)(checkoutSelector, function (checkout) {
  return checkout.error;
});
exports.checkoutErrorSelector = checkoutErrorSelector;
var _default = {
  checkoutContextSelector: checkoutContextSelector,
  checkoutDataSelector: checkoutDataSelector,
  checkoutOrderSelector: checkoutOrderSelector,
  checkoutProductSelector: checkoutProductSelector,
  checkoutShippingSelector: checkoutShippingSelector,
  checkoutCouponSelector: checkoutCouponSelector,
  checkoutErrorSelector: checkoutErrorSelector
};
exports["default"] = _default;
//# sourceMappingURL=selectors.js.map